const ContractsUiModel = {
  monthlyFees: {
    name: 'monthlyFees',
    isValid: () => true,
    isVisible: true,
    value: 0,
    errors: [],
  },
  monthlyInvestment: {
    name: 'monthlyInvestment',
    isValid: () => true,
    isVisible: false,
    value: 0,
    errors: [],
  },
  bank: {
    name: 'bank',
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    isVisible: true,
    value: {
      codigo: '',
      descripcion: '',
    },
    errors: [],
  },
  accountType: {
    name: 'accountType',
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    isVisible: true,
    value: {
      codigo: '',
      descripcion: '',
    },
    errors: [],
  },
  accountNumber: {
    name: 'accountNumber',
    isValid: (elm) => elm !== '',
    isVisible: true,
    value: '',
    errors: [],
  },
  termsAndConditions: {
    name: 'termsAndConditions',
    isValid: (elm) => elm === true,
    isVisible: true,
    value: false,
    errors: [],
  },
  inputCodeSMS: {
    name: 'inputCodeSMS',
    isValid: (elm, disabled = false) => elm.every((v) => v.length === 1 && v !== '' && !disabled),
    isVisible: true,
    value: ['', '', '', '', '', ''],
    secondsAvailableToRespond: 120,
    errors: [],
    disabled: false,
  },
};

export default ContractsUiModel;
